'use strict';

import { createApp } from 'vue';
import axios from 'axios';

createApp({
    data() {

        return {
            email: window.OLD_EMAIL || '',
            emailVerified: false,
            showPassword: false,
            emailLoading: false,
            alert: ''
        }
    },
    created()
    {
        if (this.email) this.checkEmail();
    },
    methods: {
        checkEmail()
        {
            if ( 'undefined' == typeof window.ROUTE_CHECK_EMAIL ) throw('API URL Not defined');

            if ( this.email.length == 0) return;

            this.emailLoading = true;

            axios.get(window.ROUTE_CHECK_EMAIL + '?email=' + this.email)
            .then(success => {
                
                if ( success.data['email'] ) {
                    this.alert = 'O email já está cadastrado. Por favor, insira sua senha';
                    
                    setTimeout(() => {
                        this.$el.querySelector('[type="password"]').focus();
                    }, 100);

                    this.showPassword = true;
                    return this.emailVerified = true;

                }

                let url = new URL( window.REGISTER_URL );
                if ( null == url.searchParams.get('partner_id') ) {
                    this.alert = 'O email não está cadastrado. Entre em contato com uma instituição para realizar seu cadastro';
                    return;
                }

                window.location.href = window.REGISTER_URL + '&email=' + this.email;
            })
            .catch( e => {
                /** in case of error */
                this.showPassword = true;

            })
            .finally( () => {
                this.emailLoading = false;

            })
        },
        handleSubmit(event)
        {
            if (this.emailVerified) {
                return event.target.submit();
            }

            this.checkEmail();
        }
    }
}).mount('#app');
